<template>
  <common-dialog ref="dialog" width="600px" title="修改订单价格" id-key="id" :data="data" :form-rules="rules"
    :save-func="saveDataFunc" @close-saved="$emit('close-saved')" close-on-saved>
    <template slot="form">
      <el-form-item label="订单原价格" label-width="90px">
        <span>{{ data.totalAmount }}</span>
      </el-form-item>
      <el-form-item label="修改" label-width="90px" prop="price">
        <div style="display: flex;">
          <div style="margin-right: 5px;">降价</div>
          <el-input-number v-model="data.price" :min="0" :precision="2" :step="0.1"></el-input-number>
          <div style="margin-left: 5px;">元</div>
        </div>
      </el-form-item>
    </template>
    <template slot="footer">
      <el-button type="primary" @click="save">保 存</el-button>
      <el-button @click="close">关 闭</el-button>
    </template>
  </common-dialog>
</template>
<script>
import editDialogMixin from '@/mixins/editDialog';
import commonDialog from '@/components/common/dialog';

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      api: require('@/api/ali/order').default,
      data: {
        id: 0,
        totalAmount: 0,
        price: null
      },
      rules: {
        price: [{ required: true, message: '价格不能为空' }],
      },
    };
  },
  mounted() { },
  methods: {
    saveDataFunc() {
      return new Promise((resolve, reject) => {
        this.api.modifyOrderPrice(this.data).then(res => {
          if (res.errorMessage) {
            resolve({ Code: 1, Msg: res.errorMessage })
          } else {
            resolve({ Code: 0, Msg: null })
          }
        }).catch(err => {
          reject(err);
        })
      })
    },
  },
};
</script>
